import axios from 'axios';
import { Message } from 'element-ui';
// 添加请求拦截器
axios.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axios.interceptors.response.use(
  function (response) {
    const res = response.data;
    // console.log(res);
    // 对响应数据做点什么
    if (res.code != 2000) {
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 2 * 1000,
      });
      return Promise.reject(new Error(res.msg || 'Error'));
    } else {
      return response;
    }
  },
  function (error) {
    console.log('err' + error);
    Message({
      message: error.msg,
      type: 'error',
      duration: 2 * 1000,
    });
    return Promise.reject(error);
  }
);



// WEBPACK FOOTER //
// ./config/axios.js